var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSanteMob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    zoomAndPan: "magnify",
    viewBox: "0 0 450 449.999984",
    height: 600,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7d013cf728"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225 0 C 100.734375 0 0 100.734375 0 225 C 0 349.265625 100.734375 450 225 450 C 349.265625 450 450 349.265625 450 225 C 450 100.734375 349.265625 0 225 0 Z M 225 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c8ddbda96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 450 0 L 450 450 L 0 450 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "50cbc879a9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225 0 C 100.734375 0 0 100.734375 0 225 C 0 349.265625 100.734375 450 225 450 C 349.265625 450 450 349.265625 450 225 C 450 100.734375 349.265625 0 225 0 Z M 225 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f31071fb92"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 450,
    y: 0,
    height: 450
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7d013cf728)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f31071fb92)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c8ddbda96)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50cbc879a9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -99,
    width: 648,
    fill: "#28a745",
    height: 647.999977,
    y: -98.999996,
    fillOpacity: 1
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 314.792969 204.398438 L 260.722656 204.398438 C 258.792969 204.398438 257.183594 203.433594 256.21875 201.824219 L 200.535156 103.65625 C 198.605469 100.4375 195.0625 98.183594 191.203125 98.183594 L 179.613281 98.183594 C 176.074219 98.183594 173.5 101.726562 174.464844 105.265625 L 206.328125 204.71875 L 121.679688 204.71875 C 120.070312 204.71875 118.460938 204.078125 117.175781 203.109375 L 92.070312 179.9375 C 91.105469 178.972656 89.816406 178.328125 88.207031 178.328125 L 74.691406 178.328125 C 70.828125 178.328125 68.253906 182.511719 69.863281 186.050781 L 89.171875 224.996094 L 69.863281 263.941406 C 68.253906 267.480469 70.828125 271.667969 74.691406 271.667969 L 88.53125 271.667969 C 90.140625 271.667969 91.425781 271.023438 92.390625 270.058594 L 117.496094 246.882812 C 118.785156 245.917969 120.394531 245.273438 122.003906 245.273438 L 206.972656 245.273438 L 175.109375 344.726562 C 174.144531 348.269531 176.71875 351.808594 180.257812 351.808594 L 191.84375 351.808594 C 195.707031 351.808594 199.25 349.878906 201.179688 346.335938 L 256.21875 246.882812 C 257.183594 245.273438 258.792969 244.308594 260.722656 244.308594 L 322.839844 244.308594 C 338.289062 244.308594 381.742188 226.285156 343.117188 210.191406 C 334.105469 206.328125 324.449219 204.398438 314.792969 204.398438 Z M 314.792969 204.398438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSanteMob);
export default __webpack_public_path__ + "static/media/icon_sante-mob.72f0188738bb26f13ab3f8d6140d9d1f.svg";
export { ForwardRef as ReactComponent };